/**
 * This file is needed to make testing (and mocking configs) in Jest possible.
 * It acs as single entry point to get client config
 */
export const configTracking = window.configTracking;
